import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

import { StateService } from "./services/StateService";

import "bootstrap/dist/css/bootstrap.min.css";

const state = new StateService();

// Start a background loop to query the API for infos

(async () => {
  await state
    .performInitialSync()
    .then(() => {
      state
        .backgroundSync()
        .then(() => {
          console.log("Background sync complete");
        })
        .catch((e: any) => {
          console.log("Background sync failed:", e);
        });
    })
    .catch((e: any) => {
      console.log("Initial sync failed: ", e);
    });

  ReactDOM.render(
    <React.StrictMode>
      <App state={state} />
    </React.StrictMode>,
    document.getElementById("root")
  );
})();
